/*  eslint-disable */
import SafeConsole from '../../../util/ConsoleUtils';
import SHS_WEB_experiencesDataArray from './ExperiencesV2.SHS-WEB';
import SHS_SPRINT_experiencesDataArray from './ExperiencesV2.SHS-SPRINT';
import SHS_ASURION_experiencesDataArray from './ExperiencesV2.SHS-ASURION';

let experiencesDataArray = null;

switch (globals.REACT_APP_PARTNER) {
  case 'SHS-WEB':
    experiencesDataArray = SHS_WEB_experiencesDataArray;
    break;
  case 'SHS-SPRINT':
    experiencesDataArray = SHS_SPRINT_experiencesDataArray;
    break;
  case 'SHS-ASURION':
    experiencesDataArray = SHS_ASURION_experiencesDataArray;
    break;
  case 'TCH-WEB':
    experiencesDataArray = SHS_WEB_experiencesDataArray;
    break;
  default:
    SafeConsole.error('globals.REACT_APP_PARTNER is invalid, globals.REACT_APP_PARTNER = ', globals.REACT_APP_PARTNER);
    break;
}

export default experiencesDataArray;

SafeConsole.log('Site data: experiencesDataArray version 2 = ', experiencesDataArray);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/experiences/Data/ExperiencesV2.js